function makelog(userID,action){
    let token =sessionStorage.getItem('token')
    fetch(`https://server.happyhitnow.com/hitnowlog?userid=${userID}&action=${action}&token=${token}`,{
        mode: 'cors',
    })
}export default makelog;